<template>
  <div id="punchAdmin">
    <div class="title">
      <img src="../../assets/image/icon_zzjj@2x.png" alt />
      <h3>考勤管理</h3>
    </div>
    <div class="tableContainer">
      <el-tabs v-model="organizationActive" @tab-click="handleClick">
        <!-- 月度汇总 -->
        <el-tab-pane label="月度汇总" name="1">
          <mounth-statistics v-if="organizationActive=='1'"></mounth-statistics>
        </el-tab-pane>
        <!-- 原始记录 -->
        <el-tab-pane label="原始记录" name="2">
          <back-statistics v-if="organizationActive=='2'"></back-statistics>
        </el-tab-pane>
        <!-- 考勤地点 -->
        <el-tab-pane label="考勤地点" name="3">
          <punch-place v-if="organizationActive=='3'"></punch-place>
        </el-tab-pane>
        <!-- 考勤规则 -->
        <el-tab-pane label="考勤规则" name="4">
          <punch-rules v-if="organizationActive=='4'"></punch-rules>
        </el-tab-pane>
        <!-- 考勤设置 -->
        <el-tab-pane label="考勤设置" name="5">
          <punch-set v-if="organizationActive=='5'"></punch-set>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="handleClose"
      @close="handleClosed"
      v-dialogDrag
    >
      <div slot="title" class="header-title">
        <span
          class="title-name"
          v-if="showForm=='2-edit'"
          style="color:#128BF1;margin-right:5px"
        >张某某</span>
        <span class="title-age" v-if="showForm=='1'">新增成员</span>
        <span class="title-age" v-if="showForm=='1-edit'">编辑成员</span>
        <span class="title-age" v-if="showForm=='2'">新增部门</span>
        <span class="title-age" v-if="showForm=='2-edit'">编辑部门</span>
        <span class="title-age" v-if="showForm=='3'">添加系统公告</span>
        <span class="title-age" v-if="showForm=='3-edit'">编辑系统公告</span>
      </div>
      <div class="diaContainer">
        <!-- 编辑成员管理表单 -->
        <el-form ref="form" :model="editUserForm" label-width="30%" v-if="showForm=='1-edit'">
          <el-form-item label="姓名">
            <!-- <el-input placeholder="请输入成员姓名" v-model="editUserForm.nickname"></el-input> -->
            <span style="font-size:14px">{{editUserForm.nickname}}</span>
          </el-form-item>
          <el-form-item label="部门">
            <el-select
              filterable
              :popper-append-to-body="false"
              popper-class="classChargePeople"
              class="heder40"
              v-model="editUserForm.department_id"
              placeholder="请选部门"
            >
              <el-option
                v-for="item in tableData2"
                :key="item.department_id"
                :label="item.department_name"
                :value="item.department_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="在职状态">
            <el-radio-group v-model="editUserForm.quit_status">
              <el-radio label="0">是</el-radio>
              <el-radio label="1">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否管理员">
            <el-radio-group v-model="editUserForm.admin_state">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否评价人员">
            <el-radio-group v-model="editUserForm.is_evaluators">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否冻结">
            <el-radio-group v-model="editUserForm.state">
              <el-radio label="1">是</el-radio>
              <el-radio label="0">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
        <!-- 新增部门表单 -->
        <el-form ref="form" :model="addClassForm" label-width="30%" v-if="showForm=='2'">
          <el-form-item label="部门名称">
            <el-input placeholder="请输入部门名称" v-model="addClassForm.department_name"></el-input>
          </el-form-item>
          <el-form-item label="描述">
            <el-input type="textarea" placeholder="请输入您的部门描述" v-model="addClassForm.content"></el-input>
          </el-form-item>
        </el-form>
        <!-- 编辑部门表单 -->
        <el-form ref="form" label-width="30%" v-if="showForm=='2-edit'">
          <el-form-item label="部门名称">
            <el-input placeholder="请输入部门名称" v-model="editClassForm.department_name"></el-input>
          </el-form-item>
          <el-form-item label="部门主管">
            <el-select
              filterable
              :popper-append-to-body="false"
              popper-class="classChargePeople"
              multiple
              v-model="editClassForm.chargePeople"
              placeholder="请选部门主管"
            >
              <el-option
                v-for="item in userListSelect"
                :key="item.member_id"
                :label="item.nickname"
                :value="item.member_id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="描述">
            <el-input type="textarea" placeholder="请输入您的部门描述" v-model="editClassForm.content"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button style="background-color: #ccc;" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="addFlag" @click="DiaClick">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import MounthStatistics from './punchPage/MounthStatistics'
import BackStatistics from './punchPage/BackStatistics'
import PunchPlace from './punchPage/PunchPlace'
import PunchRules from './punchPage/PunchRules'
import PunchSet from './punchPage/PunchSet'
export default {
  data() {
    return {
      addFlag: false,
      showForm: '',
      organizationActive: '1',
      searchInfo1: '',
      searchInfo2: '',
      searchInfo3: '',
      currentUserPage: 1,
      userPageSize: 10,

      currentPage1: 1,
      pageSize1: 10,
      total1: 0,
      currentPage2: 1,
      pageSize2: 10,
      total2: 0,
      currentPage3: 1,
      pageSize3: 10,
      total3: 0,

      editClassName: '',
      editClassId: '',

      token: '',
      member_id: '',
      company_id: '',
      cache_department_id: '',

      userTotal: 0,
      dialogVisible: false,
      // 新增成员
      addUserForm: {
        name: '',
        chargePeople: '',
        status: '1',
        isCharge: '1',
        isAn: '1',
        isFreeze: '1',
      },
      editUserForm: {},
      editUserId: '',
      // 新增部门表单
      addClassForm: {
        department_name: '',
        content: '',
      },
      editMessageId: '',
      // 新增消息表单
      addMessageForm: {
        title: '',
        content: '',
      },
      editMessageForm: { title: '', content: '' },
      editClassForm: { department_name: '', content: '', chargePeople: [] },
      tableData: [],
      tableData1: [],
      tableData2: [],
      tableData3: [],
      isAdmin1: '',
      isAdmin2: '',
      isAdmin3: '',
      userListSelect: [],
    }
  },
  components: {
    MounthStatistics,
    BackStatistics,
    PunchPlace,
    PunchRules,
    PunchSet,
  },
  methods: {
    handleSearch1() {
      this.currentUserPage = 1
      this.getUserList()
    },
    handleSearch2() {
      this.currentPage2 = 1
      this.getClassList()
    },
    handleSearchMessage() {
      this.currentUserPage = 1
      this.getMessageList()
    },
    DiaClick() {
      if (this.showForm === '2') {
        // 新增部门
        this.addClassFormSubmit()
      } else if (this.showForm === '2-edit') {
        // 编辑部门
        this.editClassFormSubmit()
      } else if (this.showForm === '1-edit') {
        // 编辑成员
        this.editUserFormSubmit()
      } else if (this.showForm === '3') {
        // 新增系统公告
        this.addMessageSubmit()
      } else if (this.showForm === '3-edit') {
        // 编辑系统公告
        this.editMessageSubmit()
      }
    },
    // *删除系统公告
    async handleRemoveMessage(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('notice_id', row.id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/notice_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getMessageList()
      }
    },
    // *编辑系统公告
    async editMessageSubmit() {
      if (this.editMessageForm.title.trim().length <= 0) {
        this.addFlag = false
        return this.$message.error('请填写公告标题')
      }
      if (this.editMessageForm.content.trim().length <= 0) {
        this.addFlag = false
        return this.$message.error('请填写公告内容')
      }

      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('notice_id', this.editMessageId)
      param.append('title', this.editMessageForm.title)
      param.append('content', this.editMessageForm.content)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/notice_edit',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.dialogVisible = false
      this.getMessageList()
    },
    // *新增系统公告
    async addMessageSubmit() {
      if (this.addMessageForm.title.trim().length <= 0) {
        this.addFlag = false
        return this.$message.error('请填写公告标题')
      }
      if (this.addMessageForm.content.trim().length <= 0) {
        this.addFlag = false
        return this.$message.error('请填写公告内容')
      }
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('title', this.addMessageForm.title)
      param.append('content', this.addMessageForm.content)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/notice_add',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.dialogVisible = false
      this.getMessageList()
    },
    // *获取公告列表
    async getMessageList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('search', this.searchInfo3)
      param.append('p', this.currentPage3)
      param.append('p_count', this.pageSize3)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/notice',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.tableData3 = res.datas.listInfo
      this.total3 = parseInt(res.datas.count)
      this.isAdmin3 = res.datas.admin_state
      console.log('系统公告列表', this.tableData3)
    },

    // *编辑成员提交
    async editUserFormSubmit() {
      if (!this.editUserForm.department_id) {
        return this.$message.error('请选择部门')
      }
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('to_member_id', this.editUserId)

      param.append('department_id', this.editUserForm.department_id)
      param.append('admin_state', this.editUserForm.admin_state)
      param.append('is_evaluators', this.editUserForm.is_evaluators)
      param.append('state', this.editUserForm.state)
      param.append('quit_status', this.editUserForm.quit_status)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/member_edit',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.dialogVisible = false
      this.getUserList()
    },
    // *获取成员
    async getUserList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('search', this.searchInfo1)
      param.append('department_id', '')
      param.append('p', this.currentUserPage)

      param.append('p_count', this.userPageSize)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/member',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.tableData = res.datas.listInfo
      this.userTotal = parseInt(res.datas.count)
      this.isAdmin1 = res.datas.admin_state
      console.log('成员列表', this.tableData)
    },

    // *删除部门
    async handleRemoveClass(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('department_id', row.department_id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/department_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getClassList()
      }
    },
    // *点击编辑部门
    async handleEditClass(row) {
      this.showForm = '2-edit'
      this.getUserListSelect(row.department_id)
      this.editClassForm.content = row.content
      this.editClassForm.department_name = row.department_name
      console.log('row', row)
      this.editClassForm.chargePeople = row.department_head
      this.editClassId = row.department_id
      this.dialogVisible = true
      console.log('this.editClassForm', this.editClassForm)
    },
    // 获取当前部门下的成员
    async getUserListSelect(id) {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('department_id', id)
      param.append('p_count', 10000)

      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/member',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.userListSelect = res.datas.listInfo
    },
    // *编辑部门提交
    async editClassFormSubmit() {
      if (this.editClassForm.department_name.trim().length <= 0)
        return this.$message.error('请填写部门名称')
      this.editClassForm.chargePeople =
        this.editClassForm.chargePeople.join(',')
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('department_id', this.editClassId)

      param.append('department_name', this.editClassForm.department_name)
      param.append('content', this.editClassForm.content)
      param.append('department_head', this.editClassForm.chargePeople)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/department_edit',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.dialogVisible = false
      this.getClassList()
    },
    // *新增部门提交
    async addClassFormSubmit() {
      if (this.addClassForm.department_name.trim().length <= 0)
        return this.$message.error('请填写部门名称')

      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('department_name', this.addClassForm.department_name)
      param.append('content', this.addClassForm.content)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/department_add',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.$message.success(res.datas.msg)
      this.dialogVisible = false
      this.getClassList()
    },
    // *获取部门列表
    async getClassList() {
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('search', this.searchInfo2)
      param.append('p', this.currentPage2)
      param.append('p_count', this.pageSize2)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/department',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)

      this.tableData2 = res.datas.listInfo
      this.total2 = parseInt(res.datas.count)
      this.tableData2.forEach((item) => {
        let c = []
        item.department_head.forEach((items) => {
          c.push(items.member_id)
        })
        console.log('c', c)
        item.department_head = c
        console.log(item.department_head)
      })
      this.isAdmin2 = res.datas.admin_state
      console.log('部门列表', this.tableData2)
    },
    // 点击新增成员
    addUserClick() {
      this.showForm = '1'
      this.dialogVisible = true
    },
    // *点击编辑成员
    async handleEditUser(row) {
      this.showForm = '1-edit'
      this.editUserId = row.member_id
      let param = new URLSearchParams()
      param.append('member_id', this.member_id)
      param.append('token', this.token)
      if (this.$store.state.process.app.deviceInfo) {
        param.append('device', this.$store.state.process.app.deviceInfo)
      } else {
        param.append('device', 'pc')
      }
      param.append('company_id', this.company_id)
      param.append('cache_department_id', this.cache_department_id)

      param.append('to_member_id', row.member_id)
      const { data: res } = await this.$axios({
        method: 'post',
        url: '/api/Management/member_info',
        data: param,
      })
      if (res.code != 200) return this.$message.error(res.datas.msg)
      this.editUserForm = res.datas.info
      if (this.editUserForm.department_id == '0') {
        this.editUserForm.department_id = ''
      }
      console.log('编辑成员详情', this.editUserForm)
      this.dialogVisible = true
    },
    // 点击新增部门
    addClassClick() {
      this.showForm = '2'
      this.dialogVisible = true
    },

    // 点击新增系统公告
    addMessageClick() {
      this.showForm = '3'
      this.dialogVisible = true
    },
    // 点击编辑系统公告
    handleEditMessage(row) {
      this.showForm = '3-edit'
      this.editMessageForm.title = row.title
      this.editMessageForm.content = row.content
      this.editMessageId = row.id
      this.dialogVisible = true
    },
    // 删除成员
    async handleRemoveUser(row) {
      const isDelete = await this.$confirm('是否删除', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning',
      }).catch((error) => error)
      // 如果用户点记得是取消操作
      if (isDelete === 'cancel') return this.$message('取消删除操作')
      // 如果用户点击的是删除
      if (isDelete === 'confirm') {
        // 发送删除请求
        let param = new URLSearchParams()
        param.append('member_id', this.member_id)
        param.append('token', this.token)
        if (this.$store.state.process.app.deviceInfo) {
          param.append('device', this.$store.state.process.app.deviceInfo)
        } else {
          param.append('device', 'pc')
        }
        param.append('company_id', this.company_id)
        param.append('cache_department_id', this.cache_department_id)

        param.append('to_member_id', row.member_id)
        const { data: res } = await this.$axios({
          method: 'post',
          url: '/api/Management/member_del',
          data: param,
        })
        if (res.code != 200) return this.$message.error(res.datas.msg)
        this.$message.success(res.datas.msg)
        this.getUserList()
      }
    },
    handleClick(tab, event) {
      console.log(tab, event)
      if (tab.name == '5') {
        this.$nextTick(() => {
          let a = document.getElementsByClassName('el-tabs__active-bar')
          a[0].style.marginLeft = '30px'
        })
      } else {
        this.$nextTick(() => {
          let a = document.getElementsByClassName('el-tabs__active-bar')
          a[0].style.marginLeft = '30px'
        })
      }
    },
    handleUserSizeChange(val) {
      this.userPageSize = val
      this.getUserList()
    },
    handleUserCurrentChange(val) {
      this.currentUserPage = val
      this.getUserList()
    },
    handleSizeChange1(val) {
      this.pageSize1 = val
      this.currentPage1 = 1
      this.getUserList()
    },
    handleCurrentChange1(val) {
      this.currentPage1 = val
      this.getUserList()
    },
    handleSizeChange2(val) {
      this.pageSize2 = val
      this.currentPage2 = 1
      this.getClassList()
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val
      this.getClassList()
    },
    handleSizeChange3(val) {
      this.pageSize3 = val
      this.currentPage3 = 1
      this.getMessageList()
    },
    handleCurrentChange3(val) {
      this.currentPage3 = val
      this.getMessageList()
    },
    handleClose(done) {
      this.dialogVisible = false
    },
    handleClosed() {
      this.addUserForm = {
        name: '',
        chargePeople: '',
        status: '1',
        isCharge: '1',
        isAn: '1',
        isFreeze: '1',
      }
      this.editUserForm = {}
      this.addClassForm = {
        department_name: '',
        content: '',
      }

      this.addMessageForm = {
        name: '',
        remark: '',
      }

      this.editMessageForm = { title: '', content: '' }

      this.editClassForm = {
        department_name: '',
        content: '',
        chargePeople: [],
      }

      this.editMessageId = ''
      this.editClassId = ''
      this.editUserId = ''
      this.addFlag = false
    },
  },
  created() {
    console.log('this.$route.query.type', this.$route.query.type)
    this.token = localStorage.getItem('btlh_process_token') || ''
    this.member_id = localStorage.getItem('btlh_process_member_id') || ''
    this.company_id = localStorage.getItem('bthl_process_LoginCompanyId') || ''
    this.cache_department_id =
      localStorage.getItem('bthl_process_cache_department_id_store') || ''

    if (!this.company_id) {
      this.$message.error('请重新选择您要进入的企业')
      this.$router.push('/join')
    }
    this.getUserList()
    this.getClassList()
    this.getMessageList()
  },
}
</script>
<style lang="less" scoped>
#punchAdmin {
  width: 100%;
  height: 92%;
  box-sizing: border-box;
  padding: 0 3.5%;
  .title {
    display: flex;
    align-items: center;
    padding: 30px 0 20px;
    img {
      display: block;
      width: 31px;
      margin-right: 20px;
    }
    h3 {
      font-size: 28px;
      font-weight: 400;
      color: #333;
    }
  }
  // 表格主体
  .tableContainer {
    width: 100%;
    border-radius: 10px;
    height: calc(100% - 90px - 30px);
    background-color: #fff;
    box-sizing: border-box;
    padding: 0 40px;
    padding-top: 20px;
    // 搜索行
    .searchRow {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      .btnCol {
        display: flex;
        align-items: center;
        /deep/.el-button {
          font-size: 18px;
          font-weight: normal;
          border: none;
          width: 130px;
          height: 45px;
          background: #f4a029;
          color: #fff;
          border-radius: 24px;
          padding: 0;
          margin-left: 30px;
        }
      }
    }
    /deep/.el-table__header {
      box-sizing: border-box;
      th {
        border-color: #40a0f2 !important;
      }
      .gutter {
        background-color: #40a0f2;
      }
    }
    // 分页行
    .pageRow {
      box-sizing: border-box;
      padding-top: 10px;
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      /deep/.el-pagination .el-select .el-input .el-input__inner {
        font-size: 14px;
      }
      /deep/.el-pagination button,
      /deep/.el-pagination span:not([class*='suffix']) {
        font-size: 14px;
      }
    }
    // 表格行
    /deep/.el-table__body {
      width: 100% !important;
    }
    .el-table::before {
      display: none;
    }
    /deep/.el-table__body-wrapper {
      box-sizing: border-box;
      border: 1px solid #f4f5f6;
    }
    // 鼠标经过效果
    /deep/.el-table--enable-row-hover .el-table__body tr:hover > td {
      background-color: #eff8ff;
    }
    // 斑马颜色
    /deep/.el-table--striped .el-table__body tr.el-table__row--striped td {
      background-color: #f4f5f6;
    }
    // 滚动条的宽度
    /deep/ .el-table__body-wrapper::-webkit-scrollbar {
      // position: absolute;
      // bottom: 0;
      width: 6px; // 横向滚动条
      height: 5px; // 纵向滚动条 必写
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
      background-color: #ddd;
      border-radius: 3px;
    }
    // 滚动条的滑块
    /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
      background-color: #ccc;
    }
    // *修改tabs样式
    /deep/.el-tabs__active-bar {
      width: 60px !important;
      margin-left: 30px;
    }
    /deep/.el-tabs {
      width: 100%;
      height: 100%;
      .el-tabs__header {
        width: 100%;
        margin-bottom: 20px;
        .el-tabs__nav-wrap {
          width: 100%;
          .el-tabs__nav-scroll {
            width: 100%;
            .el-tabs__nav {
              box-sizing: border-box;
              padding-left: 20px;
              width: 100%;
            }
          }
        }
      }
      .el-tabs__content {
        height: calc(100% - 80px);
        .el-tab-pane {
          height: 100%;
        }
      }
    }
    /deep/.el-tabs__item {
      height: 60px;
      text-align: center;
      font-size: 20px;
      color: #999999;
      font-weight: 400;
      padding-right: 100px;
      // width: 17%;
    }
    /deep/.el-tabs__item.is-active {
      color: #333 !important;
    }
    /deep/.el-tabs__item:hover {
      color: #333 !important;
    }
    /deep/.el-tabs__nav-wrap::after {
      color: #999999;
    }
    // 修改tabs样式
  }
  // 表格操作按钮
  .tableBtn {
    padding: 0;
    // display: flex;
    justify-content: center;
    width: 80px;
    height: 32px;
    border-color: #40a0f2;
    color: #0099ff;
    border-radius: 5px;
    font-weight: normal;
  }
  // dialog弹窗
  /deep/.el-dialog {
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px 10px 0 0;
      background-color: #f4f5f6;
      font-size: 20px;
      color: #333;
      padding-top: 20px;
      padding-bottom: 20px;
      padding-left: 40px;
    }
  }
  // 修改dia尾部按钮样式
  .dialog-footer {
    width: 100%;
    display: flex;
    .el-button {
      // width: 180px;
      width: 23%;
      height: 50px;
      padding: 0;
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      border: none;
      border-radius: 25px;
      background-color: #40a0f2;
      margin-bottom: 40px;
    }
    .el-button:first-child {
      margin-right: 5%;
    }
  }

  // 修改表单label
  /deep/.el-form-item__label {
    font-size: 16px;
    color: #333;
    box-sizing: border-box;
    padding-right: 50px;
    line-height: 40px;
  }
  // 修改内容
  /deep/.el-form-item__content {
    display: flex;
    // (deep)
    .el-select {
      width: 100%;
      .el-input {
        width: 100%;
      }
      .el-input__inner {
        width: 100%;
        // font-size: 18px;
        font-size: inherit;
      }
    }
    .el-input__inner {
      // font-size: 18px;
      font-size: inherit;
      // width: 80%;
      height: 40px;
      border-radius: 0;
    }
    .el-textarea {
      width: 80%;
      .el-textarea__inner {
        height: 250px;
        // font-size: 18px;
        font-family: Microsoft YaHei;
        font-size: inherit;
        resize: none;
        border-radius: 0;
      }
    }
    .el-radio-group {
      height: 40px;
      width: 100%;
      display: flex;
      align-items: center;
      .el-radio {
        display: flex;
        align-items: center;
        margin-right: 15%;
      }
      .el-radio__input {
        width: 18px;
        height: 18px;
        .el-radio__inner {
          width: 18px;
          height: 18px;
        }
      }
      .el-radio__label {
        // font-size: 18px;
        font-size: inherit;
      }
    }
  }
  // 修改下啦
  /deep/.classChargePeople {
    width: 160px !important;
    min-width: 160px !important;
    margin-left: 18%;
  }
  /deep/.heder40 {
    height: 56px;
  }
}
/deep/.ql-container {
  font-size: inherit;
}
.yauto {
  height: 40vh;
  overflow-y: auto;
}
.yauto::-webkit-scrollbar {
  width: 5px !important;
}
.yauto::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
/* 滚动条滑块 */
.yauto::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}
// 修改人员选择(搜索栏的人员选择)
/deep/#MyTransfer {
  width: 20%;
  .filter-dash-btn {
    border: none;
    border-radius: 24px;
    background-color: #f4f5f6;
    height: 45px;
    font-size: 16px;
    color: #333;
    .filter-tips-default {
      color: #333;
    }
  }
  .checked-app-item {
    margin-left: 10px;
    border: none;
    background-color: #f4f5f6;
  }
}
</style>